<template>
	<div>
		<h1>Monitoring</h1>

		<i
			>Data monitoring: Composition of data monitoring committee (DMC); summary
			of its role and reporting structure; statement of whether it is
			independent from the sponsor and competing interests; and reference to
			where further details about its charter can be found, if not in the
			protocol. Alternatively, an explanation of why a DMC is not needed.
			Description of any interim analyses and stopping guidelines, including who
			will have access to these interim results and make the final decision to
			terminate the trial</i
		>

		<i
			>Harms: Plans for collecting, assessing, reporting, and managing solicited
			and spontaneously reported adverse events and other unintended effects of
			trial interventions or trial conduct</i
		>

		<i
			>Auditing: Frequency and procedures for auditing trial conduct, if any,
			and whether the process will be independent from investigators and the
			sponsor</i
		>

		Will a data monitoring committee be set up?

		<InputSelectYesNo
			question="Will a data monitoring committee be set up?"
			v-model="$tera.project.TrialWizard.isCommittee"
			bookmark="monitoring-committee"
		/>

		<div v-if="$tera.project.TrialWizard.isCommittee">
			<InputTextSingleLine
				question="Provide details of the role the committee had"
				placeholder="e.g. the committee had oversight of whether the trial could be ended early due to an unacceptable number of adverse events"
				v-model="$tera.project.TrialWizard.committeeDetails"
				bookmark="committee-role"
			/>
			<InputTextSingleLine
				question="Provide details of the reporting structure of the committee"
				placeholder="e.g. the committee reported directly to the ethics board of the primary trial hospital"
				v-model="$tera.project.TrialWizard.committeeReporting"
				bookmark="reporting-structure"
			/>
			<InputTextSingleLine
				question="Provide details of the composition of the committee"
				placeholder="e.g. the committee was comprised of the director of the hospital, the head of the ethics committee and an external adverse effects consultant"
				v-model="$tera.project.TrialWizard.committeeComposition"
				bookmark="committe-composition"
			/>
			<InputTextSingleLine
				question="Further details about the committee can be found at the following link"
				placeholder=""
				v-model="$tera.project.TrialWizard.committeeLink"
				bookmark="committe-details"
			/>
		</div>

		<div v-if="!$tera.project.TrialWizard.isCommittee">
			<InputTextSingleLine
				question="List the reason(s) why a committee was not set up for this study"
				placeholder="e.g. no committee was set up for this trial as the participant numbers were so small"
				v-model="$tera.project.TrialWizard.committeeNotSetUpReasons"
				bookmark="committee-studyreason"
			/>
		</div>

		<InputSelectYesNo
			question="Will an interim analysis be conducted?"
			v-model="$tera.project.TrialWizard.isInterimAnalysis"
			bookmark="interim-analysis"
		/>

		<div v-if="$tera.project.TrialWizard.isInterimAnalysis">
			<InputTextSingleLine
				question="What time-points was the interim analysis conducted at"
				placeholder="e.g. the beginning and end of the trial"
				v-model="$tera.project.TrialWizard.interimAnalysisTimePoints"
				bookmark="time-points"
			/>
			<InputSelectMulti
				question="Interim analysis results were made available to:"
				:options="interimResultsAvailableOptions"
				v-model="$tera.project.TrialWizard.interimResultsAvailable"
				bookmark="analysis-results"
			/>
			<InputTextSingleLine
				question="The study could be stopped if..."
				placeholder="e.g. more than 10% of participants experienced severe adverse reactions"
				v-model="$tera.project.TrialWizard.earlyStop"
				bookmark="study-stopped"
			/>
			<InputSelectMulti
				question="Who made the final decision on study termination?"
				:options="finalDecisionOnTerminationOptions"
				v-model="$tera.project.TrialWizard.finalDecisionOnTermination"
				bookmark="final-decision"
			/>
		</div>

		<div v-if="!$tera.project.TrialWizard.isInterimAnalysis">
			<InputTextSingleLine
				question="List the reason(s) why an interim analysis was not planned"
				placeholder="e.g. no committee was set up for this trial as the participant numbers were so small"
				v-model="$tera.project.TrialWizard.interimNotConductedReasons"
				bookmark="notplanned-reasons"
			/>
		</div>

		<i
			>Provide plans for collecting, assessing, reporting, and managing
			solicited and spontaneously reported adverse events and other unintended
			effects of trial interventions or trial conduct</i
		>
		<InputTextSingleLine
			question="How were adverse effects monitored?"
			placeholder="e.g. by weekly check-ups with a GP to monitor blood-pressure and general health"
			v-model="$tera.project.TrialWizard.adverseEventsMonitored"
			bookmark="adverseeffects-monitered"
		/>

		<InputTextSingleLine
			question="Provide frequency and procedures for auditing trial conduct, if any, and whether the process will be independent from investigators and the sponsor"
			placeholder="e.g. weekly through an independent consultant"
			v-model="$tera.project.TrialWizard.trialAuditing"
			bookmark="frequency-auditingtrial"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputMonitoring from "./OutputMonitoring.vue";

export default {
	data() {
		return {
			outputComponent: OutputMonitoring,
			interimResultsAvailableOptions: [{ label: "DMC" }],
			finalDecisionOnTerminationOptions: [{ label: "study investigators" }]
		};
	}
};
</script>
